import axios from "axios";

/**
 * Trigger next.js revalidation endpoint for a given path.
 *
 * @param {string} path  A string like "/some/page" that should be revalidated.
 *                        It is up to the caller to supply the correct path.
 *                        If no path is supplied we fall back to the current
 *                        window location (client only).
 */
const revalidate = async (paths) => {
  const normalizedPaths = Array.isArray(paths) ? paths : [paths];
  const secret = process.env.REACT_APP_REVALIDATE_SECRET || "REVALIDATE_SECRET";

  try {
    await axios.post(
      "https://kumail.shop/api/revalidate",
      { paths: normalizedPaths.filter(Boolean) },
      {
        headers: {
          "Content-Type": "application/json",
          "x-revalidate-secret": secret,
        },
      }
    );
  } catch (err) {
    // don't break the admin UI if revalidation fails
    // eslint-disable-next-line no-console
    console.error("revalidation failed for", normalizedPaths, err);
  }
};

export default revalidate;